// placeholder used by webpack when making xhr's for code chunks
if (window.__asset_path_remove_me_please__ != null) {
  __webpack_public_path__ =
    window.__asset_path_remove_me_please__ + __OUTPUT_SUBDIR__; // eslint-disable-line
}
